export default {
      id: "icon-podcast-usage",
      viewBox: "0 0 26 29",
      url: __webpack_public_path__ + "icons.svg#icon-podcast",
      toString: function () {
        return this.url;
      }
    }